module.exports = __webpack_public_path__ + "static/56-6dccd7a828419089209659448a964a79.png";